import { Component } from '@angular/core';
import { HeroFilterComponent } from '../hero-filter/hero-filter.component';

@Component({
  selector: 'out-home-herosection',
  imports: [HeroFilterComponent],
  templateUrl: './home-herosection.component.html',
  styleUrl: './home-herosection.component.scss',
})
export class HomeHerosectionComponent {
  selectedTabText = ' Used Tesla For Sale';

  updateText(tabIndex: number) {
    const tabTexts = [' Used Tesla For Sale', 'Sell My Tesla'];
    // const tabTexts = ['The Smarter Way to Search, List, and Buy Teslas', 'Sell My Tesla'];
    this.selectedTabText = tabTexts[tabIndex];
  }
}
